import i18n from '../../locales/index'
import restful from '../vuex'
// import axios from 'axios'
// import { Message } from 'view-design'

const state = {
  ...restful.states('sms_charge')
}

const getters = {
  ...restful.getters('sms_charge')
}

const actions = {
  ...restful.actions('sms_charges', 'CONFIG'),
  // async alipay_url ({ commit }, params) {
  //   // console.log(commit, params)
  //   // Message.error('正在开发中')
  //   Message.success({ content: '正在跳转到支付页', duration: 10, top: 300 })
  //   const res = await axios.post('sms_charges/alipay_url', params)
  //   const url = res.data
  //   window.location.href = url
  // }
}

const mutations = {
  ...restful.mutations('sms_charge')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
